/// <amd-module name="Test/PassRateChartView/Actions/PassRateChartActionsCreator" />
import { AnnouncementActions } from "Test/Analytics/Common/Actions/AnnouncementActions";
import * as CommonTypes from "Test/Analytics/Common/Types";
import * as TcmPerfScenarios from "Test/Analytics/Common/Utils/TCMPerfScenarios";
import * as TcmTelemetryConstants from "Test/Analytics/Common/Utils/TcmTelemetryConstants";
import { publishEvent } from "Test/Analytics/Common/Utils/TelemetryService";
import { TestReportDataParser } from "Test/common-util/Common.Utils";
import { PassRateChartActions } from "Test/PassRateChartView/Actions/PassRateChartActions";
import * as Resources from "Test/PassRateChartView/Resources";
import { PassRateChartSource } from "Test/PassRateChartView/Sources/PassRateChartSource";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssPerformanceService } from "VSS/Platform/Performance";

export class PassRateChartActionsCreator {
    private _passedRateChartSource: PassRateChartSource;
    private _perfService: IVssPerformanceService;
    constructor(private _actions: PassRateChartActions, private _announcementActions: AnnouncementActions, private _pageContext: IVssPageContext) {
        this._passedRateChartSource = new PassRateChartSource(_pageContext);
        this._perfService = _pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
    }

    public updateConfigurationValues(newConfValues: CommonTypes.IReportConfiguration): void {
        this._actions.updateConfigurationValuesAction.invoke(newConfValues);
    }

    public updatePassedRateChart(testReportContext: CommonTypes.ITestReportContext, confValues: CommonTypes.IReportConfiguration): Promise<void> {
        this._perfService.startScenario(TcmPerfScenarios.TestAX_PassRateCard, false);

        return this._passedRateChartSource.queryTestOutcomeCountMetricData(testReportContext, confValues).then(
            (passedRateChartData: CommonTypes.ICardMetricsData) => {
                passedRateChartData.passPercentage = TestReportDataParser.getPercentageInDisplayFormat(Number(passedRateChartData.passPercentage), 2);
                this._actions.updatePassRateChartAction.invoke(passedRateChartData);
                this._announcementActions.announceAction.invoke(Resources.PassRateChartLoaded);

                // Telemetry
                const telemetryData: { [key: string]: string | number } = {
                    [TcmTelemetryConstants.Passed]: passedRateChartData.passedCount,
                    [TcmTelemetryConstants.Failed]: passedRateChartData.failedCount,
                    [TcmTelemetryConstants.NotExecuted]: passedRateChartData.notExecutedCount,
                    [TcmTelemetryConstants.IsCached]: String(passedRateChartData.isCachedData)
                };

                this._perfService.endScenario(TcmPerfScenarios.Area, TcmPerfScenarios.TestAX_PassRateCard, false, undefined, telemetryData);
                publishEvent(this._pageContext, TcmTelemetryConstants.featureTestAX_PassRateCard, telemetryData, testReportContext, confValues);
            },
            (error: Error) => {
                this._actions.onError.invoke(error);
                this._perfService.endScenario(TcmPerfScenarios.Area, TcmPerfScenarios.TestAX_PassRateCard, false, undefined, { status: "error" });
            }
        );
    }
}
